 <template>
  <router-view/>
</template> 
